import { render } from "./wishBox.vue?vue&type=template&id=336f89ba"
import script from "./wishBox.vue?vue&type=script&lang=js"
export * from "./wishBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__